/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./content.css";
import { useNavigate } from "react-router";

const Home = () => {
  const [mainText, setMainText] = useState("");
  const [arMainText, setArMainText] = useState("");
  const [heroDescription, setHeroDescription] = useState("");
  const [arHeroDescription, setArHeroDescription] = useState("");
  const [heroImage, setHeroImage] = useState(null);
  const [heroImageAlt, setHeroImageAlt] = useState("");
  const [images, setImages] = useState({
    one: { file: null, preview: null, alt: "" },
    two: { file: null, preview: null, alt: "" },
    three: { file: null, preview: null, alt: "" },
    four: { file: null, preview: null, alt: "" },
  });
  const [aboutDescription, setAboutDescription] = useState("");
  const [arAboutDescription, setArAboutDescription] = useState("");

  const [homeData, setHomeData] = useState(null);
  const [value, setValue] = useState("");
  const [valueImage, setValueImage] = useState(null);
  const [valueImageAlt, setValueImageAlt] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [questionTitle, setQuestionTitle] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [questions, setQuestions] = useState([]);
  const [boxesToShow, setBoxesToShow] = useState(7);
  const [questionsToShow, setQuestionsToShow] = useState(3);
  const [boxTitle, setBoxTitle] = useState("");
  const [arBoxTitle, setArBoxTitle] = useState("");
  const [boxText, setBoxText] = useState("");
  const [arBoxText, setArBoxText] = useState("");
  const [selectedBoxId, setSelectedBoxId] = useState(null);
  const [boxes, setBoxes] = useState([]);

  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/dashboard/login");
    }
  }, [token, navigate]);

  const handleFileUpload = (file, key) => {
    const preview = URL.createObjectURL(file);
    setImages((prevImages) => ({
      ...prevImages,
      [key]: { file, preview, alt: prevImages[key].alt },
    }));
  };

  const handleAltChange = (altText, key) => {
    setImages((prevImages) => ({
      ...prevImages,
      [key]: { ...prevImages[key], alt: altText },
    }));
  };

  const handleImageDelete = (key) => {
    setImages((prevImages) => ({
      ...prevImages,
      [key]: { file: null, preview: null, alt: "" },
    }));
  };

  const handleSaveSectionOne = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("mainText", mainText);
    formData.append("arMainText", arMainText);
    formData.append("heroDescription", heroDescription);
    formData.append("arHeroDescription", arHeroDescription);
    formData.append("aboutDescription", aboutDescription);
    formData.append("arAboutDescription", arAboutDescription);

    if (heroImage) {
      formData.append("heroImage", heroImage);
    }
    formData.append("heroImageAlt", heroImageAlt);

    const imagesData = [
      { file: images.one.file, alt: images.one.alt, key: "images[0]" },
      { file: images.two.file, alt: images.two.alt, key: "images[1]" },
      { file: images.three.file, alt: images.three.alt, key: "images[2]" },
      { file: images.four.file, alt: images.four.alt, key: "images[3]" },
    ];

    imagesData.forEach((image) => {
      if (image.file) {
        formData.append(image.key, image.file);
        formData.append(`${image.key}_alt`, image.alt);
      }
    });

    toast
      .promise(
        axios.post("/content/home", formData, {
          headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
        }),
        {
          pending: "Uploading data...",
          success: "Section saved successfully!",
          error: "Error uploading data.",
        }
      )
      .then((response) => {
        console.log("Saved successfully:", response.data);
      })
      .catch((error) => {});
  };

  const handleAddBox = async (e) => {
    e.preventDefault();

    if (!boxTitle || !arBoxTitle || !boxText || !arBoxText) {
      return toast.error("Please fill out all fields.");
    }

    const boxData = {
      boxTitle,
      arBoxText,
      boxText,
      arBoxTitle,
    };

    try {
      const response = await toast.promise(
        axios.post("/content/boxes", boxData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          pending: "Adding box...",
          success: "Box added successfully!",
        }
      );
      setBoxTitle("");
      setArBoxTitle("");
      setBoxText("");
      setArBoxText("");
      setShowPopup(false);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };

  const handleDeleteConfirm = (boxId) => {
    setSelectedBoxId(boxId);
    setShowConfirmation(true);
  };

  const handleDeleteBox = async () => {
    try {
      await axios.delete(`/content/boxes/${selectedBoxId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setBoxes(boxes.filter((box) => box._id !== selectedBoxId));
      toast.success("Box has been deleted..!");
      setShowConfirmation(false);
      setSelectedBoxId(null);
    } catch (error) {
      toast.error(
        error.response.data.message || "An error occurred while deleting."
      );
    }
  };

  const handleToggleShowBoxes = () => {
    if (boxesToShow > 7) {
      setBoxesToShow(7);
    } else if (boxesToShow === 7) {
      setBoxesToShow(boxes?.length);
    }
  };

  const handleShowPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get("/content/home");
        setHomeData(response?.data);
      } catch (error) {
        toast.error("Failed to fetch data. Please try again later.");
      }
    };

    const fetchBoxes = async () => {
      try {
        const response = await axios.get("/content/boxes");
        setBoxes(response?.data);
      } catch (error) {}
    };

    const fetchQuestions = async () => {
      try {
        const response = await axios.get("/content/questions");
        setQuestions(response?.data);
      } catch (error) {}
    };

    fetchHomeData();
    fetchBoxes();
    fetchQuestions();
  }, []);

  return (
    <div className="dash-content home">
      <div className="container">
        <form onSubmit={handleSaveSectionOne}>
          <div className="section one">
            <h1 className="dash-title">Home</h1>
            <div className="input">
              <h2>Main Text</h2>
              <input
                type="text"
                placeholder={homeData?.mainText}
                value={mainText}
                onChange={(e) => setMainText(e.target.value)}
              />
              <h2 dir="rtl">النص الاساسي</h2>
              <input
                dir="rtl"
                type="text"
                placeholder={homeData?.arMainText}
                value={arMainText}
                onChange={(e) => setArMainText(e.target.value)}
              />
              <h2>Hero Description</h2>
              <textarea
                placeholder={homeData?.heroDescription}
                value={heroDescription}
                onChange={(e) => setHeroDescription(e.target.value)}
              ></textarea>
              <h2 dir="rtl">الوصف</h2>
              <textarea
                dir="rtl"
                placeholder={homeData?.arHeroDescription}
                value={arHeroDescription}
                onChange={(e) => setArHeroDescription(e.target.value)}
              ></textarea>
              <h2>Hero Image</h2>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setHeroImage(e.target.files[0])}
              />
              <h2>Alt</h2>
              <input
                type="text"
                placeholder={homeData?.heroImage?.alt}
                value={heroImageAlt}
                onChange={(e) => setHeroImageAlt(e.target.value)}
              />
            </div>
          </div>

          <div className="section two">
            <div className="about-images">
              <h2>About Images</h2>
              <div className="images">
                {Object.keys(images).map((key) => (
                  <div className="image-container" key={key}>
                    <div className="image">
                      {images[key].preview ? (
                        <div className="image-preview">
                          <img src={images[key].preview} alt="Preview" />
                          <button
                            type="button"
                            className="delete-btn"
                            onClick={() => handleImageDelete(key)}
                          >
                            <i className="uil uil-trash-alt"></i>
                          </button>
                        </div>
                      ) : (
                        <>
                          <i className="uil uil-image-v"></i>
                          <p>Drop your image here, or</p>
                          <div className="btn">
                            <button type="button">Click here</button>
                            <input
                              type="file"
                              onChange={(e) =>
                                handleFileUpload(e.target.files[0], key)
                              }
                              accept="image/*"
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <input
                      type="text"
                      placeholder="Alt text"
                      value={images[key].alt}
                      onChange={(e) => handleAltChange(e.target.value, key)}
                    />
                  </div>
                ))}
              </div>
            </div>
            <h2>About Description</h2>
            <textarea
              placeholder={homeData?.aboutDescription}
              value={aboutDescription}
              onChange={(e) => setAboutDescription(e.target.value)}
            ></textarea>
            <h2 dir="rtl">الوصف</h2>
            <textarea
              dir="rtl"
              placeholder={homeData?.arAboutDescription}
              value={arAboutDescription}
              onChange={(e) => setArAboutDescription(e.target.value)}
            ></textarea>
          </div>

          <button className="submit">Save</button>
        </form>
        <hr />
        <div className="section three">
          <h2>Text Boxes</h2>
          <div className="values">
            <div className="boxes">
              <div className="add-value" onClick={handleShowPopup}>
                <i className="uil uil-plus"></i>
              </div>
              {boxes?.slice(0, boxesToShow)?.map((box, index) => (
                <div className="box" key={box?._id}>
                  <button className="remove-btn">
                    <i
                      className="uil uil-trash-alt"
                      onClick={() => handleDeleteConfirm(box?._id)}
                    ></i>
                  </button>
                  <h3
                    style={{
                      color: "var(--main-color)",
                    }}
                  >
                    {index + 1}.{box?.boxTitle}
                  </h3>
                  <p
                    style={{
                      width: "90%",
                      textAlign: "center",
                    }}
                  >
                    {box?.boxText}
                  </p>
                </div>
              ))}
            </div>

            {showPopup === true && (
              <div className="value-popup">
                <form className="popup-content" onSubmit={handleAddBox}>
                  <div className="head">
                    <h2>Box</h2>
                    <i className="uil uil-times" onClick={handleClosePopup}></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Box Title"
                    value={boxTitle}
                    onChange={(e) => setBoxTitle(e.target.value)}
                  />
                  <input
                    className="ar-input"
                    type="text"
                    placeholder="عنوان المربع"
                    value={arBoxTitle}
                    onChange={(e) => setArBoxTitle(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Box Text"
                    value={boxText}
                    onChange={(e) => setBoxText(e.target.value)}
                  />
                  <input
                    className="ar-input"
                    type="text"
                    placeholder="نص المربع"
                    value={arBoxText}
                    onChange={(e) => setArBoxText(e.target.value)}
                  />
                  <button>Add</button>
                </form>
              </div>
            )}

            {boxes?.length > 7 && (
              <p className="show-more" onClick={handleToggleShowBoxes}>
                Show {boxesToShow === 7 ? "more" : "less"}
              </p>
            )}

            {showConfirmation && (
              <div className="confirmation-modal">
                <div className="modal-content">
                  <img src="/photos/question.svg" alt="?" />
                  <p>Are you sure you want to delete this box?</p>
                  <div className="modal-actions">
                    <button onClick={handleDeleteBox}>Yes</button>
                    <button onClick={() => setShowConfirmation(false)}>
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
};

export default Home;
